import React, { useState } from 'react';

import {
  ButtonToDropdownMenu,
  type ButtonToDropdownMenuItemConfig,
} from 'src/common/ui/components';

/**
 * Chart Property Menu
 */
export const ChartPropertyMenu: React.FC<{
  allowNone: boolean;
  isEmpty: boolean;
  isEmptyValue: boolean;
  markAsNone: () => void;
  setShowHistoryModal: (doShowModal: boolean) => void;
  setShowNotes: (doShowNotes: boolean) => void;
  showingNotes: boolean;
}> = ({
  allowNone,
  isEmpty,
  isEmptyValue,
  markAsNone,
  setShowHistoryModal,
  setShowNotes,
  showingNotes,
}) => {
  const [showNotesDelay, setShowNotesDelay] = useState(showingNotes);

  const menuItems: ButtonToDropdownMenuItemConfig[] = [
    {
      label: 'Show notes',
      onClick: () => setShowNotes(true),
      disabled: showNotesDelay,
    },
    ...(allowNone
      ? [
          {
            label: !isEmpty ? 'Mark as none' : 'Unset None',
            onClick: markAsNone,
            disabled: !isEmptyValue,
          },
        ]
      : []),
    {
      label: 'History',
      onClick: () => setShowHistoryModal(true),
    },
  ];

  const handleMenuExited = () => {
    // This fires after the menu transition completes (like original TransitionProps.onExited)
    if (showingNotes) {
      setShowNotesDelay(true);
    }
  };

  return (
    <ButtonToDropdownMenu
      menuItems={menuItems}
      testId="chart-property-menu"
      onMenuExited={handleMenuExited}
    />
  );
};
